import { isUntitledScriptId } from "./stagingModel";

// The transform rows a deploy would leave behind (TTTL-254). A deploy
// sends the pipeline code, which names scripts by file; the engine reads
// the stored file, so an edited stored script runs as it was last saved,
// and an untitled draft — no file yet — drops out of the code entirely.
// The deploy check (deployBlockers) counts both as unsaved scripts.

export interface UnsavedScripts {
  /** Stored scripts with unsaved edits, by row name, in staging order. */
  edited: string[];
  /** Untitled drafts, which have no file to deploy. */
  untitled: number;
}

export function unsavedScripts(
  scriptDrafts: Record<string, string>,
  transforms: ReadonlyArray<{ id: string; name: string }>,
): UnsavedScripts {
  const found: UnsavedScripts = { edited: [], untitled: 0 };
  for (const row of transforms) {
    const text = scriptDrafts[row.id];
    if (text == null) continue;
    // A stored row keeps a draft only while it differs from the saved
    // file, so even a blank one is an edit — the emptied script would
    // deploy as last saved. A blank untitled draft has nothing to lose.
    if (!isUntitledScriptId(row.id)) found.edited.push(row.name);
    else if (text.trim() !== "") found.untitled += 1;
  }
  return found;
}

/** The untitled rows, blank or not: none of them is in the deployed code,
 *  so a deploy that lands drops them the way their minus does, rather than
 *  leaving rows on a deployed pipeline that look like part of it. */
export function untitledScriptRowIds(
  transforms: ReadonlyArray<{ id: string }>,
): string[] {
  return transforms
    .filter((row) => isUntitledScriptId(row.id))
    .map((r) => r.id);
}
